import styled from 'styled-components';
import { CheckboxMixin } from '../../mixins/components/CheckboxMixin';
import { FormControl } from '../FormControl/FormControl';
export var StyledCheckbox = /*#__PURE__*/styled(FormControl).withConfig({
  displayName: "StyledCheckbox",
  componentId: "c11n-8-107-0__sc-13jdanj-0"
})(["", ""], CheckboxMixin);